import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into <head> for the lifetime of the component.
 * Client-side injection is sufficient for JS-executing crawlers (Googlebot).
 * Each instance is keyed by `id` so re-renders replace rather than duplicate.
 */
interface JsonLdProps {
  id: string;
  data: Record<string, unknown> | Array<Record<string, unknown>>;
}

export function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [id, data]);

  return null;
}
